<template>
    <booking-cancel></booking-cancel>
    <booking-idle></booking-idle>

    <div class="stay">
        <div class="container">
            <div class="page-intro">
                <h1>BOOK A ROOM</h1>
            </div>

            <div class="mb-4">
                <progress-bar></progress-bar>
            </div>
        </div>
        <router-view></router-view>
    </div>

</template>

<script>

    import BookingCancel from '../components/BookingCancel.vue';
    import BookingIdle from '../components/BookingIdle.vue';
    import ProgressBar from '../components/ProgressBar.vue';

    export default {
        name: 'Booking',
        components: {
            BookingCancel,
            ProgressBar,
            BookingIdle,
        }
    }
</script>


<style src="@/css/booking/booking.css"></style>